import React, { useState, useContext } from "react";
import { FiTrash2, FiEdit, FiPlay, FiPause } from "react-icons/fi";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import { GrDrag } from "react-icons/gr";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import { Container, Actions } from "./styles";

import { AnswerContext } from "../../../../index";

function Item({ item, index }) {
  const [openActions, setOpenActions] = useState(false);
  const { state, dispatch } = useContext(AnswerContext);
  const isMobile = useMediaQuery("(max-width:426px)");

  function handleRemove() {
    dispatch({ type: "REMOVE_ITEM", index: index });
  }

  function handleEdit() {
    setOpenActions(false);
    dispatch({ type: "START_EDIT_ITEM", index: index });
  }

  function handleEnable() {
    dispatch({
      type: "UPDATE_ITEM",
      index: index,
      item: { ...item, is_active: !item.is_active },
    });
  }

  return (
    <ClickAwayListener onClickAway={() => setOpenActions(false)}>
      <Container
        onMouseEnter={() => setOpenActions(!isMobile)}
        onClick={() => setOpenActions(true)}
        onMouseLeave={() => setOpenActions(false)}
        inactive={!item.is_active}
      >
        <span class="limit-text">{item.printDescription}</span>
        <span style={{ marginLeft: "5px" }}>
          {item.price.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })}
        </span>

        {openActions && !state.inEditing.status && (
          <Actions>
            <Tooltip arrow placement="bottom" title="Ordenar">
              <GrDrag
                style={{
                  position: "absolute",
                  left: "0",
                  top: "9px",
                  fontSize: "20px",
                  opacity: "0.2",
                }}
              />
            </Tooltip>
            <ButtonGroup disableElevation variant="text" color="primary">
              {item.is_active ? (
                <Tooltip arrow placement="bottom" title="Pausar">
                  <Button onClick={handleEnable}>
                    <FiPause style={{ fontSize: "20px" }} />
                  </Button>
                </Tooltip>
              ) : (
                <Tooltip arrow placement="bottom" title="Ativar">
                  <Button onClick={handleEnable}>
                    <FiPlay style={{ fontSize: "20px" }} />
                  </Button>
                </Tooltip>
              )}
              <Tooltip arrow placement="bottom" title="Alterar">
                <Button onClick={handleEdit}>
                  <FiEdit style={{ fontSize: "20px" }} />
                </Button>
              </Tooltip>
              <Tooltip arrow placement="bottom" title="Excluir">
                <Button onClick={handleRemove}>
                  <FiTrash2 style={{ color: "red", fontSize: "20px" }} />
                </Button>
              </Tooltip>
            </ButtonGroup>
          </Actions>
        )}
      </Container>
    </ClickAwayListener>
  );
}

export default Item;
